import "./dom-qGGG2YCX.js";
import { i as o } from "./isUndefined-B5qXrATz.js";
const s = (t, r) => {
  const e = r.find((n) => t === n.value);
  if (o(e))
    throw new Error("[getItemByValue]: Item not found.");
  return e;
}, m = (t, r) => t.map((e) => s(e, r)), l = async (t, r) => r.filter((e) => new RegExp(t, "i").test(e.label));
export {
  s as getItemByValue,
  m as getItemsByValue,
  l as searchItemsByLabel
};
